module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_120-cf83a40ed720a7adea196905a6bf8016.png";